<template>
    <v-container>
        <v-row>
            <v-card width="100%" class="mx-1">
                <Menu></Menu>
            </v-card>
        </v-row>
        <v-card class="mt-4" v-if="!shownewURL">
            <v-card-title class="primary">
                <v-toolbar-title id="titulocard">Generar URL Acortada</v-toolbar-title>
            </v-card-title>
            <v-card-text>
                <v-row justify="center">
                    <v-col cols="12" md="7">
                        <v-row>
                            <v-col cols="12">
                                <v-form ref="form" v-model="validForm" lazy-validation>
                                    <span style="font-weight: bold;">URL Completa:</span>
                                    <v-text-field outlined width="20px" dense v-model="busqueda.longUrl"
                                        :rules="rules"></v-text-field>
                                    <span style="font-weight: bold;">Sitio:</span>
                                    <multiselect v-model="busqueda.ntsitio"
                                        deselect-label="No se puede remover el valor seleccionado"
                                        selected-label="Seleccionado" select-label="Seleccione un estado de cita"
                                        track-by="saclave" label="sitio" placeholder="Seleccione un sitio"
                                        :options="Sitio.CatalogoSitios" :allow-empty="false">
                                    </multiselect>
                                    <span v-if="valSitio" style="color: #FF5C93; font-size: 11px">Campo
                                        requerido</span>
                                </v-form>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions style="justify-content: center; align-content:end; padding: 20px;">
                <div mt-2>
                    <v-btn class="mr-4" color="#536DFE" style="color:white" @click="generar()"
                        :disabled="btndis">Generar</v-btn>
                    <v-btn class="mr-4" color="default" @click="limpiar()" :disabled="btndis">Limpiar</v-btn>
                    <v-btn class="mr-4" color="secondary" style="color:white" @click="cancelar()"
                        :disabled="btndis">Cancelar</v-btn>
                </div>
            </v-card-actions>
        </v-card>
        <v-card class="mt-4" v-else>
            <v-card-title class="primary">
                <v-toolbar-title id="titulocard">Generar URL Acortada</v-toolbar-title>
            </v-card-title>
            <v-card-text>
                <v-row justify="center">
                    <v-col cols="12" md="7">
                        <v-row>
                            <v-col cols="12" md="10">
                                <span style="font-weight: bold;">URL Acortada:</span>
                                <v-text-field outlined width="20px" dense maxlength="7" readonly filled
                                    v-model="busqueda.short"></v-text-field>
                            </v-col>
                            <v-col cols="12" md="2" style="display: grid; place-items: center;">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn color="primary" fab dark small v-bind="attrs" v-on="on"
                                            @click="copiar()">
                                            <v-icon size="20" :color="'#FFFFFF'"> mdi-content-copy </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Copiar</span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn color="secondary" fab dark small v-bind="attrs" v-on="on"
                                            @click="compartir()">
                                            <v-icon size="18" :color="'#FFFFFF'"> mdi-share </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Abrir</span>
                                </v-tooltip>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions style="justify-content: center; align-content:end; padding: 20px;">
                <div mt-2>
                    <v-btn class="mr-4" color="secondary" style="color:white" @click="Regresar()">Regresar</v-btn>
                </div>
            </v-card-actions>
        </v-card>
    </v-container>
</template>

<script>
import { mapState } from "vuex";
import Menu from '@/components/pages/Sistemas/MenuSistemas.vue';
import Sistemas from "@/services/Sistemas/sistemas.service.js";
import MetodosGenerales from '@/utils/metodosgenerales.vue.js';

export default {
    title() {
        return this.$route.meta.title
    },
    components: {
        Menu,
    },
    data: function () {
        return {
            Sitio: {
                CatalogoSitios: [],
                ntsitio: '',
            },
            busqueda: {
                ntsitio: null,
                longUrl: null,
                short: null
            },
            val: 0,
            valSitio: false,
            validForm: true,
            rules: [
                v => !!v || 'Campo requerido',
            ],
            btndis: false,
            shownewURL: false,
            permisoSistemas: false,
            uslogin: null,
        }
    },
    watch: {
        'busqueda.ntsitio'(val) {
            if (val != null) {
                this.valSitio = false;
            }
        }
    },
    computed: {
        ...mapState(["domain", "informationPage", "permission"]),
    },
    async beforeMount() {
        await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '60').then(response => {
            if (response.data.length > 0) {
                response.data.forEach(permiso => {
                    if (permiso.peclave == 60)//Permiso para Sistemas
                        this.permisoSistemas = true;
                });
            } else {
                this.$router.push({ name: `NoAutorizado` }).catch(error => error);
            }
        });
    },
    async mounted() {
        this.uslogin = await MetodosGenerales.ObtenerUserName();
        await Sistemas.CatalogoAcortador(this);
    },
    methods: {
        limpiar() {
            this.busqueda.ntsitio = null;
            this.busqueda.longUrl = null;
            this.valSitio = false;
            this.$refs.form.reset()
        },
        cancelar() {
            this.$router.push({ name: 'AcortadorBusqueda' }).catch((error) => error);
        },
        async validar() {
            this.val = 0;
            this.$refs.form.validate()
            if (this.busqueda.ntsitio == null) {
                this.valSitio = true;
                this.val++;
            }
            const longUrl = this.busqueda && this.busqueda.longUrl ? this.busqueda.longUrl.trim() : "";
            if (longUrl.length == 0) {
                this.val++;
            }
        },
        async generar() {
            await this.validar();
            if (this.val == 0) {
                this.$swal({
                    title: 'Actualizando URL, espere, por favor.',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: async () => {
                        this.$swal.showLoading();
                        this.btndis = true;
                        let response = await Sistemas.AgregarURLAcortada(this.busqueda.ntsitio.saclave, this.busqueda.longUrl.trim(), this.uslogin);
                        if (response == null) {
                            this.$swal({
                                position: 'center',
                                icon: 'info',
                                title: 'Información',
                                text: 'Está en localhost y no puede hacer peticiones debido a la protección IP, cambié en ctparametro al localhost',
                                showConfirmButton: true,
                                confirmButtonColor: '#536DFE',
                                confirmButtonText: 'Aceptar',
                                allowOutsideClick: false,
                                timer: 2500,
                            }).then(async () => {
                                this.btndis = false;
                            });
                            this.btndis = false;
                        } else if (response.error) {
                            response.msg = response.msg == 'Enlace a acortar invalido' ? 'Enlace a acortar inválido' : response.msg;
                            this.$swal({
                                position: 'center',
                                icon: 'warning',
                                title: 'Error',
                                text: response.msg,
                                showConfirmButton: true,
                                confirmButtonColor: '#536DFE',
                                confirmButtonText: 'Aceptar',
                                allowOutsideClick: false,
                                timer: 2500,
                            }).then(async () => {
                                this.btndis = false;
                            });
                        } else {
                            this.$swal({
                                position: 'center',
                                icon: 'success',
                                title: 'Éxito',
                                text: 'URL Acortada generada correctamente.',
                                showConfirmButton: true,
                                confirmButtonColor: '#536DFE',
                                confirmButtonText: 'Aceptar',
                                allowOutsideClick: false,
                                timer: 2500,
                            }).then(async () => {
                                this.shownewURL = true;
                                this.busqueda.short = response.msg;
                            });
                        }
                    }
                })
            }
        },
        async Regresar() {
            this.shownewURL = false;
            this.busqueda.ntsitio = null;
            this.busqueda.longUrl = null;
            this.btndis = false;
        },
        copiar() {
            MetodosGenerales.copiarTextoPlano(this, 'Url copiada', 2000, this.busqueda.short);
        },
        compartir() {
            window.open(this.busqueda.short, '_blank');
        }

    }
}
</script>
<style></style>